import { FilterIcon } from 'ui-components/dist/FilterIcon';
import { useGroupFilters } from '~/screens/MyAgency/hooks/useGroupFilters';
import {
  useAdvancedFiltersStore,
  useTalentFiltersStore,
} from '~/screens/store';

import { AgencyHeaderButton } from '../Table/AgencyHeaderButton';
import { useTalentPageFiltersStore } from './useTalentPageFiltersStore';

export function TalentPageFilterToggle() {
  const { openGlobalFiltersDrawer } = useTalentPageFiltersStore();
  const { appliedFilters: audienceFilters } = useAdvancedFiltersStore();
  const { filtersSize: talentFiltersSize } = useTalentFiltersStore();
  const audienceFiltersGrouped = useGroupFilters(audienceFilters);

  const totalFilterSize = talentFiltersSize + audienceFiltersGrouped.length;

  return (
    <AgencyHeaderButton
      onClick={openGlobalFiltersDrawer}
      icon={FilterIcon}
      title={`Filters ${totalFilterSize > 0 ? `(${totalFilterSize})` : ''}`}
      aria-label="Filters"
      iconOnly={false}
      track-id="foam-myagency-global-filters"
    />
  );
}
